import { RadioButtonListProps } from "@interfaces/uiElementTypes";
import RadioButton from "./RadioButton";

const RadioButtonList: React.FC<RadioButtonListProps> = ({
  options,
  defaultValue,
  selectedValue,
  setSelectedValue,
  className,
}) => {
  return (
    <div
      className={`grid w-full gap-4 ${className} no-scrollbar overflow-y-scroll`}
    >
      {options.map((option) => (
        <div key={option.value} className="flex-grow">
          <RadioButton
            label={option.label}
            value={option.value}
            checked={selectedValue === option.value}
            onChange={setSelectedValue}
          />
        </div>
      ))}
    </div>
  );
};

export default RadioButtonList;
